module.exports = __webpack_public_path__ + "edc100a18f1b9141a075eb4352cd740f.png";